






















import { ElTable } from "element-ui/types/table";
import { Mixins, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { IScriptExecuteParameter } from "../../../../../../../documaker/domain/format/objects";
import { VariableParameterMixin } from "../mixins";

@Component
export default class ScriptExecuteParameterSelector extends Mixins(VariableParameterMixin) {
  @Prop({ default: false })
  shouldShowIsFixed: boolean;

  @Prop({ default: "" })
  label: string;

  @Prop({ default: () => [] as IScriptExecuteParameter[] })
  parameters: IScriptExecuteParameter[];

  @Prop({ default: () => [] as { key: string, value: string }[] })
  parameterNames: { key: string, value: string }[];

  $refs!: {
    table: ElTable,
  };

  toIsFixedString(row: IScriptExecuteParameter): string {
    return row.isFixed
      ? "固定値"
      : "可変値";
  }

  toParameterString(row: IScriptExecuteParameter): string {
    return row.isFixed
      ? row.parameter
      : !!this.VariableParameterDictionary[row.parameter]
        ? "[" + this.VariableParameterDictionary[row.parameter] + "]"
        : "[" + row.parameter + "]";
  }

  @Watch("options")
  onOptionsUpdated(newValue: IScriptExecuteParameter[], oldValue: IScriptExecuteParameter[]) {
    // element-uiのテーブルにスクロールバーが表示される際、ヘッダがずれる問題に対応するため、dataプロパティ更新時に遅延でdoLayoutを呼び出す
    this.$nextTick(() => this.$doWhenValid(t => t.doLayout(), this.$refs.table));
  }

  @Emit()
  selectionChange(value: IScriptExecuteParameter[]): void {}
}
